import {
  keepPreviousData,
  useMutation,
  useQuery,
  useQueryClient,
} from '@tanstack/react-query';
import { toast } from 'sonner';

import type { ApiError } from '@/core/api';
import * as api from './api';

export const feedKeys = {
  items: ['feeds', 'items'] as const,
  itemList: (p: api.FeedItemListParams) => [...feedKeys.items, p] as const,
  sources: ['feeds', 'sources'] as const,
};

export function useFeedItems(params: api.FeedItemListParams = {}) {
  return useQuery({
    queryKey: feedKeys.itemList(params),
    queryFn: () => api.listFeedItems(params),
    placeholderData: keepPreviousData,
  });
}

export function useFeedSources() {
  return useQuery({
    queryKey: feedKeys.sources,
    queryFn: () => api.listFeedSources(),
  });
}

export function useRefreshFeedSource() {
  const qc = useQueryClient();
  return useMutation({
    mutationFn: (id: number) => api.refreshFeedSource(id),
    onSuccess: ({ created }) => {
      qc.invalidateQueries({ queryKey: feedKeys.items });
      qc.invalidateQueries({ queryKey: feedKeys.sources });
      toast.success(created ? `Fetched ${created} new item${created === 1 ? '' : 's'}` : 'No new items');
    },
    onError: (err: ApiError) => toast.error(err.message),
  });
}
